<div *ngIf="showContinueButton" class="redirect-window">
  <div class="alert alert-info">
    <br />
    <img src="pwa-48.png" />
    <br />
    <br />
    <span style="font-size: 120%;"><b>{{ 'WelcomeToScanWritr' | translate }}</b></span>
    <br />
    <br />
    <span><b>{{ 'RedirectBeginEditingSubtitle' | translate }}</b></span>
    <br />
    <br />
    <span>{{ 'RedirectBeginEditingDescription' | translate }}</span>
    <br />
    <br />
  </div>
  <button class="btn btn-default btn-upload btn-upload-social btn-upload-file" (click)="start()">{{'Continue' | translate}}</button>
</div>
<div *ngIf="!showContinueButton" id="pageLoaderDiv" class="page-loader">
  <div class="centered-div-outer">
    <div class="centered-div-middle">
      <div class="centered-div-inner opening-page">
        <div class="loadingFileSpinner"></div>
        <div>{{ 'LoadingFile' | translate }}…</div>
      </div>
    </div>
  </div>
</div>
